import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import schema from 'components/Deliverable/Search/schema';
import NavigationProvider from 'components/Navigation/Provider';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import { RoutePrivateProps } from 'components/Route/Private/types';
import { DeliverablesQuery } from 'components/Deliverable/Form/graphql';

const DeliverableForm = React.lazy(
  () => import('components/Deliverable/Form/Form'),
);

function ScreensDeliverablesForm(params: Readonly<RoutePrivateProps>) {
  const id = params.id ? Number(params.id) : null;
  return (
    <BaseLayout className="background-blue">
      <DocumentTitle>{params.id ? 'Edit' : 'Create'} deliverable</DocumentTitle>
      <NavigationProvider
        id={id}
        buildUrl={(nid: string) => `/deliverables/${nid}/edit`}
        schema={schema}
        query={DeliverablesQuery}
      >
        <Suspense fallback={<UILoader />}>
          <DeliverableForm id={id} key={params.id} />
        </Suspense>
      </NavigationProvider>
    </BaseLayout>
  );
}

export default ScreensDeliverablesForm;
